const plugin = require('tailwindcss/plugin');

module.exports = {
  purge: ['./resources/new-site-app/**/*.vue'],

  theme: {
    debugScreens: {
      selector: '.debug-screens',
      position: ['bottom', 'left'],
      prefix: 'screen: ',
    },
    extend: {
      fontFamily: {
        roboto: 'Roboto, sans-serif',
        garamond: ['Cormorant Garamond', 'sans-serif'],
      },

      screens: {
        '1xl': '1440px',
        '2xl': '1536px',
        '3xl': '1920px',
      },

      colors: {
        p10: '#7068FF',
        ma: '#534CDA',
        b5: '#0D0D0D',
        b15: '#262626',
        b20: '#333333',
        b30: '#4D4D4D',
        b40: '#666666',
        b50: '#808080',
        b60: '#999999',
        b70: '#B3B3B3',
        b78: '#CCCBCE',
        b80: '#CCCCCC',
        b85: '#D9D1C3',
        b90: '#E6E6E6',
        b95: '#F2F2F2',
        b97: '#F7F7F7',
        b99: '#FCFCFC',
        p5: '#2D2E4A',
        p10: '#595A77',
        p15: '#8687A5',
        p20: '#9C9DBB',
        p25: '#B2B3D2',
        p30: '#C9CAE8',
        p40: '#DFE0FF',

        gray50: '#E6E6E6',

        'ma-black-0': '#151515',
        'ma-black-1': '#4A4A4A',
        'ma-gray-0': '#F7F7F7',
        'ma-gray-1': '#DCDCDC',
        'ma-gray-11': '#E9E9E9',
        'ma-gray-2': '#C9C9C9',
        'ma-gray-22': '#BFBEBE',
        'ma-gray-3': '#999999',
        'ma-blue-0': '#227584',
        'ma-blue-1': '#67C7D8',
        'ma-teal-0': '#CEEDF2',
        'ma-teal-1': '#B9CDD4',
        'ma-teal-2': '#73A9B2',
        'ma-red-1': '#E06969',
        'ma-red-2': '#E33333',
        'ma-red-3': '#CA514E',
        'ma-green-1': '#B8E986',
        'ma-green-2': '#96CD89',
        business: {
          dark: '#00011D',
          light: '#FFF1D6',
        },
        primary: {
          green: '#DBFF00',
          'green-hover': '#CAEB00',
          beige: '#FFF9EE',
          'dark-beige': '#F0E8D9',
          gray: '#CCCBCE',
          purple: '#00011D',
          red: '#BF0268',
          'light-purple': '#CCCCE2',
          'dark-purple': '#212139',
          offwhite: '#FFFDFA',
        },
      },

      opacity: {
        5: '.05',
        20: '.2',
        80: '.80',
      },
    },
  },

  variants: {},

  plugins: [
    require('tailwindcss-debug-screens'),
    plugin(function ({ addComponents, theme }) {
      const buttons = {
        '.al-btn': {
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',

          height: '44px',
          paddingLeft: '50px',
          paddingRight: '50px',
          borderRadius: '4px',

          fontWeight: 600,
          fontSize: '15px',

          transition: 'all 250ms',

          '&:focus': {
            outline: 0,
          },
        },

        '.al-btn--primary': {
          backgroundColor: theme('colors.primary.green'),
          color: theme('colors.primary.purple'),
          borderRadius: '8px',
          '&:hover': {
            backgroundColor: theme('colors.primary.green-hover'),
          },
        },
        '.al-btn--primary-dark': {
          backgroundColor: theme('colors.primary.purple'),
          color: theme('colors.primary.beige'),
          borderRadius: '8px',
          '&:hover': {
            backgroundColor: theme('colors.primary.dark-purple'),
          },
        },

        '.al-btn--primary-outline': {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '8px',
          borderColor: theme('colors.primary.green'),
          color: '#DBFF00',
          '&:hover': {
            backgroundColor: theme('colors.primary.green'),
          },
        },
        '.al-btn--primary-dark-outline': {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '8px',
          borderColor: theme('colors.primary.purple'),
          color: theme('colors.primary.purple'),
          '&:hover': {
            color: theme('colors.primary.beige'),
            backgroundColor: theme('colors.primary.purple'),
          },
        },

        '.al-btn--indigo': {
          backgroundColor: '#3d65c4',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#4472e1',
          },
        },

        '.al-btn--gray': {
          backgroundColor: '#efefef',
          color: '#2d2d2d',
          '&:hover': {
            backgroundColor: '#eaeaea',
          },
        },
        '.al-btn--white': {
          backgroundColor: '#ffffff',
          color: 'rgba(255, 255, 255, 0.40)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
          },
        },
        '.al-btn--white-outline': {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#ffffff',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        },
        '.al-btn--black-outline': {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#0D0D0D',
          color: '#0D0D0D',
          '&:hover': {
            backgroundColor: 'rgba(13, 13, 13, 0.1)',
          },
        },
        '.al-btn--red': {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '8px',
          borderColor: '#E43E52',
          backgroundColor: '#E43E52',
          color: '#FFF9EE',
          '&:hover': {
            borderColor: '#A52D3C',
            backgroundColor: '#A52D3C',
          },
        },
        '.al-btn--red-outline': {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '8px',
          borderColor: '#CA514E',
          color: '#CA514E',
          '&:hover': {
            backgroundColor: 'rgba(202,81,78, 0.1)',
          },
        },
      };

      addComponents(buttons, {
        variants: ['responsive'],
      });
    }),
  ],
};
